import React from "react";
import { STATUS_META, TYPE_META, classifyType } from "../lib/incidents";

export function StatusBadge({ status, className = "" }) {
  const meta = STATUS_META[status] || STATUS_META.ACTIVE;
  return (
    <span
      data-testid={`status-badge-${status?.toLowerCase()}`}
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 text-[12px] font-bold uppercase tracking-[0.12em] rounded-sm border ${className}`}
      style={{ color: meta.color, background: meta.bg, borderColor: meta.border }}
    >
      <span
        className="w-1.5 h-1.5 rounded-full"
        style={{ background: meta.color, boxShadow: `0 0 6px ${meta.color}` }}
      />
      {meta.label}
    </span>
  );
}

export function TypeBadge({ type, className = "" }) {
  const key = classifyType(type);
  const meta = TYPE_META[key];
  return (
    <span
      data-testid={`type-badge-${key.toLowerCase()}`}
      className={`inline-flex items-center px-2 py-0.5 text-[12px] font-semibold uppercase tracking-wider rounded-sm border ${className}`}
      style={{ color: meta.color, borderColor: `${meta.color}55`, background: `${meta.color}15` }}
    >
      {meta.label}
    </span>
  );
}
